import { analytics } from "./analytics";
import API from "../store/services/api";

export const SERVICE_SESSION_EVENT = "printbox-service-session";
const TOKEN_KEY = "service_token";
const CAPABILITIES_KEY = "service_capabilities";
const FREE_PRINT_KEY = "service_free_print";

const notify = () => window.dispatchEvent(new Event(SERVICE_SESSION_EVENT));

export const getServiceToken = () => sessionStorage.getItem(TOKEN_KEY);

export const getServiceCapabilities = () => {
    try {
        return JSON.parse(sessionStorage.getItem(CAPABILITIES_KEY) || "[]");
    } catch {
        return [];
    }
};

export const hasServiceCapability = (capability) =>
    Boolean(getServiceToken()) && getServiceCapabilities().includes(capability);

export const isFreePrintEnabled = () =>
    hasServiceCapability("free_print") &&
    sessionStorage.getItem(FREE_PRINT_KEY) !== "false";

export const setFreePrintEnabled = (enabled) => {
    sessionStorage.setItem(FREE_PRINT_KEY, enabled ? "true" : "false");
    notify();
};

export const saveServiceSession = (data) => {
    if (!data?.service_token) {
        clearServiceSession();
        return;
    }
    sessionStorage.setItem(TOKEN_KEY, data.service_token);
    sessionStorage.setItem(
        CAPABILITIES_KEY,
        JSON.stringify(data.service_capabilities || []),
    );
    sessionStorage.setItem(FREE_PRINT_KEY, "true");
    notify();
};

export const clearServiceSession = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(CAPABILITIES_KEY);
    sessionStorage.removeItem(FREE_PRINT_KEY);
    notify();
};

const serviceHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Device-Token": localStorage.getItem("deviceToken"),
    "Service-Token": getServiceToken(),
});

export const heartbeatServiceSession = async () => {
    if (!getServiceToken()) return null;
    const response = await API.get("/api/v1/service/session", {
        headers: serviceHeaders(),
    });
    return response.data;
};

export const closeServiceSession = async () => {
    if (!getServiceToken()) return;
    try {
        await API.delete("/api/v1/service/session", {
            headers: serviceHeaders(),
        });
    } catch {
        // Локально закрываем в любом случае. Серверный TTL — страховка, если
        // сеть уже пропала.
    }
};

export const endKioskSession = () => {
    analytics.endSession("reset");
    void closeServiceSession();
    clearServiceSession();
    localStorage.removeItem("access_token");
    localStorage.removeItem("role");
};

export const getServiceTrays = async () => {
    const response = await API.get("/api/v1/service/trays", {
        timeout: 15000,
        headers: serviceHeaders(),
    });
    return response.data;
};

export const refillServiceTray = async (trayId, countPages) => {
    const response = await API.post(
        `/api/v1/service/trays/${trayId}/refill`,
        { count_pages: countPages },
        { headers: serviceHeaders(), timeout: 15000 },
    );
    return response.data;
};

export const sendServiceCommand = async (command, params = {}) => {
    const response = await API.post(
        "/api/v1/service/commands",
        { command, params },
        { headers: serviceHeaders(), timeout: 15000 },
    );
    return response.data;
};

export const getServiceCommandStatus = async (commandId) => {
    const response = await API.get(
        `/api/v1/service/commands/${commandId}`,
        { headers: serviceHeaders(), timeout: 15000 },
    );
    return response.data;
};

export const createFreePrint = async (payments) => {
    const requestId =
        window.crypto?.randomUUID?.() ||
        "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
            const value = Math.floor(Math.random() * 16);
            return (char === "x" ? value : (value & 0x3) | 0x8).toString(16);
        });
    const response = await API.post(
        "/api/v1/service/free-print",
        { request_id: requestId, payments },
        { headers: serviceHeaders() },
    );
    return response.data;
};
